// Module
var code = `<div class="row justify-content-center">
	<div class="col-12 col-md-6 col-lg-4">
		<div class="card">
			<div class="card-header">
				<back-button default-state="manager.library" class="btn btn-outline-primary"></back-button>
				<span ng-if="!\$ctrl.edit" class="h4 card-title">Create new Service Announcement</span>
				<span ng-if="\$ctrl.edit" class="h4 card-title">Edit Service Announcement</span>
			</div>
			<form name="editForm" ng-submit="\$ctrl.submit(editForm.\$valid)">
				<div class="card-body">
					<div class="mb-3">
						<label for="name" class="form-label">Name</label>
						<input id="name" type="text" ng-model="\$ctrl.item.name" placeholder="Give it a name" required="required" minlength="1" class="form-control" />
					</div>
					<div class="mb-3">
						<label for="headline" class="form-label">Headline</label>
						<input id="headline" type="text" ng-model="\$ctrl.item.headline" required="required" minlength="1" class="form-control" />
					</div>
					<div class="mb-3">
						<label for="Body" class="form-label">Body</label>
						<textarea id="body" type="text" ng-model="\$ctrl.item.body" rows="5" required="required" minlength="1" class="form-control"></textarea>
					</div>
				</div>
				<div class="card-footer d-flex justify-content-between">
					<button ng-if="\$ctrl.edit" type="button" ng-click="\$ctrl.remove()" ng-disabled="\$ctrl.item.sceneCollections" class="btn btn-danger">
						<i class="far fa-trash-can"></i>
						<span>Delete</span>
					</button>
					<div ng-if="!\$ctrl.edit"></div>
					<button type="submit" ng-disabled="\$ctrl.item.name.length === 0 || \$ctrl.item.headline.length === 0 || \$ctrl.item.body.length === 0 || ((\$ctrl.item.name === \$ctrl.org.name) &amp;&amp; (\$ctrl.item.headline === \$ctrl.org.headline) &amp;&amp; (\$ctrl.item.body === \$ctrl.org.body))" class="btn btn-primary">
						<span ng-if="!\$ctrl.edit">Add</span>
						<span ng-if="\$ctrl.edit">Save</span>
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
`;
// Exports
export default code;